import React from 'react';
import Image from 'gatsby-image';
import {ArticlePhotos} from './ArticlePhotos';
import {useAuthorsData} from '../../Authors/useAuthorsData';
import OgImage from '../../../../assets/images/blog/article_12/aktualne-wymiary-grafik-na-instagramie-linkedinie-pinterescie-i-twitterze_og.png';

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();
  return {
    date: '25.10.2022r',
    category: 'social media, Facebook',
    title: (<>Aktualne wymiary grafik na Instagramie, LinkedInie, Pintereście i Twitterze <br/>[Aktualizacja: Październik 2022]</>),
    SEO_title:
      'Aktualne wymiary grafik na Instagramie, LinkedInie, Pintereście i Twitterze',
    description:
      'Jakie wymiary grafik najlepiej stosować na Instagramie, a jakie sprawdzą się na Pintereście? Takich pytań w internecie jest mnóstwo, co świadczy tylko o tym, że jest to temat, który ciągle cieszy się zainteresowaniem. Dlatego w tym artykule rozwiewamy wszystkie wątpliwości i podajemy aktualne wymiary obrazów i zdjęć w social mediach.',
    seo:
      'Jakie wymiary grafik najlepiej stosować na Instagramie, a jakie sprawdzą się na Pintereście? Takich pytań w internecie jest mnóstwo, co świadczy tylko o tym, że jest to temat, który ciągle cieszy się zainteresowaniem.',
    slug: '/blog/aktualne-wymiary-grafik-na-instagramie-linkedinie-pinterescie-i-twitterze',
    image: OgImage,
    authors: [
      authors.DariaPyziak,
      authors.AlexMechew,
    ],
    hero: (
      <Image
        alt=""
        objectPosition={'center'}
        objectFit={'contain'}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        text:
          'Wymiary grafik, które zostały przedstawione we wpisie, są polecane przez poszczególne portale społecznościowe. Jednak doświadczenie nauczyło nas tego, że nie zawsze sprawdzają się one najlepiej. Dlatego podajemy również te, z których sami korzystamy.',
      },
      second: {
        title: 'Jakie wymiary grafik stosować w social mediach?',
      },
      third: {
        title: 'INSTAGRAM',
        text: 'Instagrama nie trzeba nikomu przedstawiać. Portal ten od lat jest powszechny na rynku i stanowi wizytówkę marki.',
      },
      fourth: {
        title: 'Zdjęcie profilowe',
        text: 'Podobnie jak na Facebooku, zdjęcie profilowe na Instagramie jest w formie kwadratu, jednak wyświetla się jako okrąg. Dlatego portal poleca użycie grafik o wymiarze 110 x 110 px.',
      },
      fifth: {
        title: 'InteractiveVision poleca',
        text: 'W odróżnieniu od Facebooka zdjęcia profilowego na Instagramie nie dasz rady powiększyć. Niemniej jednak lepiej zadbać o odpowiednią jakość Twojego awatara. Rekomendujemy wymiar 1000x1000 px.',
      },
      sixth: {
        title: 'Grafika kwadratowa:',
        text: 'Standardowy wymiar obrazu jako post to 1080 x 1080 px.',
      },
      seventh: {
        title: 'Grafika pozioma:',
        text: '  Wymiary, które są rekomendowane przez serwis przy stosowaniu grafik poziomych, to 1080 x 566 px, czyli proporcje 1.91:1.',
      },
      eighth: {
        title: 'Grafika pionowa:',
        text: 'Inna propozycja przedstawienia treści to post pionowy. Rekomendowany wymiar to 1080 x 1350 px (proporcje 5:4).',
      },
      ninth: {
        title: 'InteractiveVision poleca:',
        text: '  Na naszym profilu na Instagramie korzystamy z grafik kwadratowych 1080x1080 px. Tym samym mamy pewność, że nic nie zostanie przycięte, a cały feed wygląda spójnie i przejrzyście. ',
      },
      tenth: {
        title: 'Wymiary grafik do Instagram Stories',
        text: 'Dzięki relacji na Instagram Stories można przekazać krótkie komunikaty w formie zdjęcia lub filmu. Wymiar rekomendowany przez serwis to 1080 x 1920 px.',
      },
      eleventh: {
        title: 'Miniatura IGTV',
        text: 'Filmy na IGTV zyskują na popularności, jednak aby odpowiednio się wyświetlały, potrzebują miniatury. Sugerowany rozmiar to 420 x 654, czyli proporcja 1:1,55',
      },
      twelfth: {
        title: 'InteractiveVision poleca:',
        text: 'Pamiętaj, aby nie ustawiać ważnych elementów w rogach grafiki! Miniaturka powinna być czytelna.',
      },
      thirteenth: {
        title: 'LINKEDIN',
        text: (<>
          <strong>Miejsce, z którego korzystają rekruterzy i poszukujący pracy. Odpowiednie grafiki na LinkedInie wzbogacą Twój profil i mogą przyczynić się do sukcesu w kontaktach zawodowych. </strong>
          <br/>Posty poziome to jedne z najczęściej używanych formatów publikowanych postów na Facebooku. Grafiki tego typu najlepiej prezentują się w rozmiarze 1200 x 900 px.</>),
      },
      fourteenth: {
        title: 'Zdjęcie profilowe',
        text: 'Do zdjęcia profilowego na profilu osobistym serwis poleca stosowanie wymiarów od 400 × 400px do 7680 × 4320px. Natomiast na profilu firmowym - 300 x 300 px. W obu przypadkach rekomenduje wykorzystanie zdjęcia, którego nie trzeba przycinać.',
      },
      fifteenth: {
        title: 'InteractiveVision poleca:',
        text: 'Zarówno przy koncie osobistym, jak i profilu firmy polecany przez nas wybór to 1000x1000px.',
      },
      sixteenth: {
        title: 'Zdjęcie w tle',
        text: 'Specjaliści polecają wykorzystanie rozmiaru 1584 × 396 px na profilu osobistym, a 1536 x 768 px na profilu firmowym.',
      },
      seventeenth: {
        title: 'InteractiveVision poleca:',
        text: 'Wymiary, które proponujemy, to: 1128x191px na profilu firmowym i 792x198 na profilu osobistym.',
      },
      eighteenth: {
        title: 'Grafika do postu',
        text: 'Na profilu osobistym i firmowym najlepiej stosować grafiki, których wymiary to 1200 x 628 px.',
      },
      nineteenth: {
        title: 'InteractiveVision poleca:',
        text: 'Podane wymiary stosujemy do grafik w poście z linkiem. Natomiast naszym najlepszym dotychczasowym rozwiązaniem jest grafika 1200x1200. ',
      },
      twentyth: {
        title: 'PINTEREST',
        text: <>
          <strong>Źródło inspiracji i pomysłów dla wielu twórców.</strong> Standardowy Pin powinien mieć proporcje 3:2 - 1000 x 1500. Natomiast maksymalne wymiary zdjęcia profilowego to 165 x 165 px. Popularnością cieszą się również kwadratowe Piny, których szerokość i wysokość wynosi 1000 px.
        </>,
      },
      twentyfirst: {
        title: 'InteractiveVision poleca:',
        text: 'Proponujemy użyć nieco większego zdjęcia profilowego - 600x600px będzie dobrym wyborem.',
      },
      twentysecond: {
        title: 'TWITTER',
        text: <>
          <strong>Portal społecznościowy wykorzystywany głównie przez polityków, ludzi z showbiznesu oraz firmy, którzy publikują swoje myśli, artykuły czy wyrażają swój światopogląd. Których wymiarów grafik używać na Twitterze? Odpowiedź poniżej.</strong></>,
      },
      twentythird: {
        title: 'Zdjęcie profilowe',
        text: '400 x 400 px - taki rozmiar jest najlepszy do zdjęcia profilowego według serwisu. Zdjęcie dodawane jest w formie kwadratu, jednak wyświetlane jest jako okrąg.',
      },
      twentyfourth: {
        title: 'Zdjęcie w tle',
        text: 'Cover photo jest uzupełnieniem każdego profilu. Rozmiar rekomendowany przez Twitter to 1500 x 500 px.',
      },
      twentyfifth: {
        title: 'Tweet',
        text: 'Serwis daje możliwość publikacji postów o różnych wymiarach, jednak będą one prezentowane w proporcjach 1200 x 628 px. ',
      },
    },
    list: {
      first: {
        title: 'Zanim zaczniesz skalować obrazy, pamiętaj, że…',
        content: [
          'Najlepsza rozdzielczość grafik w social mediach to 72dpi,',
          'Waga grafiki powinna zmieścić się w przedziale 100-350kB,',
          'Niewiele osób zainteresuje się Twoją grafiką, jeśli będzie na niej więcej niż 20% tekstu,',
          'Format .png to format, który jest niezastąpiony w mediach społecznościowych,',
          'Obrazy najlepiej prezentują się w profilu kolorów sRGB.',
        ],
      },
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_4.childImageSharp.fluid}
        />
      ),
      fifth: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_5.childImageSharp.fluid}
        />
      ),
      sixth: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_6.childImageSharp.fluid}
        />
      ),
      seventh: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_7.childImageSharp.fluid}
        />
      ),
      eight: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_8.childImageSharp.fluid}
        />
      ),
      ninth: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_9.childImageSharp.fluid}
        />
      ),
      tenth: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_10.childImageSharp.fluid}
        />
      ),
      eleventh: (
        <Image
          alt=""
          objectPosition={'center'}
          objectFit={'contain'}
          fluid={images.img_11.childImageSharp.fluid}
        />
      ),
    },
    ending: 'Życzymy miłego skalowania obrazów!',
  };
};
